<template>
  <div class="adsense-container">
    <ins
      class="adsbygoogle"
      :style="style"
      data-ad-client="ca-pub-9415047994846214"
      :data-ad-slot="adSlot"
      :data-ad-format="adFormat"
      :data-ad-layout="adLayout"
      :data-full-width-responsive="adResponsive"
      :key="adSlotKey"  <!-- Dynamic key to force re-render -->
    ></ins>
  </div>
</template>

<script>
export default {
  props: {
    adSlot: { type: String, required: true },
    adFormat: { type: String, default: 'auto' },
    adLayout: { type: String, default: null },
    adResponsive: { type: Boolean, default: true },
    customStyle: { type: Object, default: () => ({ width: '100%', height: 'auto' }) }
  },
  data() {
    return {
      adSlotKey: Date.now() // Unique key to force re-render of the ad
    };
  },
  computed: {
    style() {
      return Object.assign({ display: 'inline-block' }, this.customStyle);
    }
  },
  mounted() {
    this.loadAdScript();  // Load the AdSense script dynamically
  },
  watch: {
    // Watch for route changes or any reactive variable that changes on page navigation
    $route() {
      this.resetAd(); // Reset the ad on page navigation
    }
  },
  methods: {
    resetAd() {
      // Reset the key to force re-render of the <ins> element
      this.adSlotKey = Date.now();
      this.loadAd();  // Load the ad again
    },
    loadAdScript() {
      // Check if the script is already loaded
      if (!window.adsbygoogle) {
        const script = document.createElement('script');
        script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
        script.async = true;
        script.onload = this.loadAd;  // Load the ad once the script is ready
        document.head.appendChild(script);
      } else {
        // If the script is already loaded, just load the ad
        this.loadAd();
      }
    },
    loadAd() {
      // Ensure adsbygoogle is available and load the ad
      if (window.adsbygoogle && window.adsbygoogle.loaded) {
        // Push the new ad into the <ins> element
        (adsbygoogle = window.adsbygoogle || []).push({});
      } else {
        // Retry if adsbygoogle is not ready
        setTimeout(this.loadAd, 1000);
      }
    }
  }
};
</script>

<style scoped>
.adsense-container {
  margin: 20px 0;
  text-align: center;
}
</style>
